import BaseApiAction from "@Actions/base-api-action";
export default class UpdatePlaySession extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: "sessions-updatePlaySessionV3",
      payload: { ...this._payload },
    });
  }
}
